import { http } from "../../stempcore";
import URL from "../assets/conf/setting.json";

// const yurl = 'http://yapi.smarket.net.cn/mock/8/';
const url = URL.template.api.gateway.general + "/";
export const apiUrl = URL.template.api.gateway.general;
export default {
  aggregationConfigGet: info => {
    "use strict";
    return http.post("api/webinar/aggregation/config/get", info, {
      url: url
    });
  },
  // 获取模版配置
  getTempSetting: info => {
    "use strict";
    return http.post("api/webinar/aggregation/page/config/get", info, {
      url: url
    });
  },
  // 获取首页数据
  getIndexList: info => {
    "use strict";
    return http.post("api/webinar/aggregation/index/get", info, {
      url: url
    });
  },
  // 获取分类字段信息
  getCategory: info => {
    "use strict";
    return http.post("api/webinar/aggregation/getcategory", info, {
      url: url
    });
  },
  // 获取列表
  getAggregationQuery: info => {
    "use strict";
    return http.post("api/webinar/aggregation/query", info, {
      url: url
    });
  },
  getContact: info => {
    "use strict";
    return http.post("api/member/contacts/info/get", info, {
      url: url
    });
  },
  logout(info) {
    "use strict";
    return http.post("member/member/associate/Logout", info, {
      url: url
    });
  }
};
